import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Image } from 'expo-image';
import ExploreCardOverlay from './ExploreCardOverlay';
import { exploreMediaZoomStyles as mz } from './exploreCardMediaZoomStyles';

const ExploreCardImage = React.memo(({ item, style, hovered }) => {
  return (
    <>
      <View style={mz.clip}>
        <View style={[mz.zoom, hovered && mz.zoomHovered]}>
          <Image
            source={{ uri: item.thumbnailPath || item.cdnPath }}
            style={[styles.image, style]}
            pointerEvents="none"
            contentFit="cover"
            placeholder={item.blurhash ? { blurhash: item.blurhash } : undefined}
            transition={200}
            recyclingKey={item.id}
            priority="low"
          />
        </View>
      </View>
      <ExploreCardOverlay
        prompt={item.displayName || item.prompt}
        modelName={item.modelName}
        modelSlug={item.modelSlug}
        mediaType="image"
        isPlusShowcase={item.flags?.isPlusShowcase}
        hovered={hovered}
        variationCount={item.variationCount}
      />
    </>
  );
});

const styles = StyleSheet.create({
  image: {
    ...StyleSheet.absoluteFillObject,
  },
});

export default ExploreCardImage;
